import { SupabaseTableBase } from '../../utils/SupabaseTableBase';
import { CallToneSuggestion } from './types';

export class CallToneSuggestionService extends SupabaseTableBase<CallToneSuggestion> {
  constructor() {
    super('callToneSuggestion');
  }

  async createSuggestion(callId: string, suggestion: string, datetime: string): Promise<CallToneSuggestion | null> {
    const suggestionData = {
      callId,
      suggestion,
      datetime
    };

    const result = await this.insertRecord(suggestionData);
    return result.data;
  }

  async getSuggestionsByCallId(callId: string): Promise<CallToneSuggestion[]> {
    const result = await this.selectRecordsByColumn('callId', callId, {
      orderBy: 'datetime',
      ascending: true
    });

    return result.data || [];
  }
}
